/*
 * Limiter zapytań serwera (np. okna wizualizacji - limit per jednostka) odpowiada 429 z nagłówkiem Retry-After
 * w pełnych sekundach. Do tego terminu kolejne zapytanie zostałoby odrzucone tak samo.
 */

// bez poprawnego nagłówka kolejna próba po takim czasie
const DEFAULT_FALLBACK_MS = 10000;

/**
 * Termin najwcześniejszej kolejnej próby (ms od epoki) po odpowiedzi 429: teraz + Retry-After, a bez poprawnego
 * nagłówka teraz + fallbackMs.
 */
export function getRetryNotBefore(error, fallbackMs = DEFAULT_FALLBACK_MS, now = Date.now()) {
    const headers = error && error.response ? error.response.headers : undefined;
    const value = headers ? String(headers["retry-after"] ?? "").trim() : "";

    return now + (/^\d+$/.test(value) ? Number(value) * 1000 : fallbackMs);
}
